<template>
  <div class="flex gap-x-1 h-28 bg-EXPONDO-white p-2 border rounded border-EXPONDO-grey-20">
    <CustomLink
      :url="link"
      :type="LINK_TYPE.NoStyle"
      class="flex flex-col justify-center min-w-[46px] w-[46px]"
      @link-click="handleCardClick"
    >
      <TwicpicsImage
        :src="image"
        :alt="title"
        :width="TILE_MINI_CARD.IMAGE_WIDTH"
        :height="TILE_MINI_CARD.IMAGE_HEIGHT"
      />
    </CustomLink>
    <div class="flex flex-col justify-between flex-grow">
      <CustomLink
        :url="link"
        :type="LINK_TYPE.NoStyle"
        @link-click="handleCardClick"
      >
        <p class="line-clamp-3 text-xs underline">
          {{ title }}
        </p>
      </CustomLink>
      <EnergyRating
        v-if="energyRating"
        :energy-rating="energyRating"
        :size="ENERGY_RATING_SIZE.SMALL"
      />
      <CustomLink
        :url="link"
        :type="LINK_TYPE.NoStyle"
        @link-click="handleCardClick"
      >
        <ProductFinalPrice
          :final-price="isDiscounted ? discountedPrice : fullProductPrice"
          :is-discounted="isDiscounted"
          class="text-sm"
        />
      </CustomLink>
    </div>
  </div>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { EnergyRatingDetails } from '~~/types/components/EnergyRating/EnergyRatingDetails';
import { ENERGY_RATING_SIZE } from '~~/constants/energyRating';
import { TILE_MINI_CARD } from '~~/constants/productCard';

import type { ProductCategories } from '~~/types/product/ProductCategories';

export default defineComponent({
  name: 'MiniProductCardTile',

  props: {
    link: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    productBoxTypeTag: {
      type: String,
      required: true,
    },
    fullProductPrice: {
      type: Number,
      required: true,
    },
    energyRating: {
      type: Object as PropType<Maybe<EnergyRatingDetails>>,
      default: (): Maybe<EnergyRatingDetails> => null,
    },
    sku: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    discountedPrice: {
      type: Number,
      default: null,
    },
    brand: {
      type: String,
      default: '',
    },
    categories: {
      type: [Object, String] as PropType<ProductCategories>,
      required: true,
    },
  },
  emits: ['product-clicked'],
  setup(props, { emit }) {

    const { trackClickProductBox } = useGtmEvents();

    const isDiscounted = computed(() => {

      return props.discountedPrice > 0;
    
    });

    const handleCardClick = () => {

      emit('product-clicked');

      trackClickProductBox({
        boxType: props.productBoxTypeTag,
        product: {
          sku: props.sku,
          name: props.title,
          currency: props.currency,
          discountedPrice: props.discountedPrice,
          brand: props.brand,
          price: props.fullProductPrice,
          categories: props.categories,
        },
      });
    
    };

    return {
      LINK_TYPE,
      ENERGY_RATING_SIZE,
      TILE_MINI_CARD,
      handleCardClick,
      isDiscounted,
    };
  
  },
});

</script>
